var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "formula-formulate-adapter" },
    [
      _vm._t(
        "form",
        [
          _c(
            "formulate-form",
            {
              key: _vm.formulateKey,
              ref: "form",
              model: {
                value: _vm.input,
                callback: function($$v) {
                  _vm.input = $$v
                },
                expression: "input"
              }
            },
            [
              _c(
                "div",
                { staticClass: "flex gap-4 flex-col" },
                [
                  _vm._l(_vm.fieldDefinitions, function(field) {
                    return [
                      field.type !== "group" && _vm.shouldShow(field.name)
                        ? _c("formulate-field-adapter", {
                            key: field.name,
                            attrs: {
                              disabled: _vm.viewOnly,
                              value: field,
                              bindValidation: function() {
                                return _vm.customValidation(field)
                              }
                            },
                            on: { mounted: _vm.loadFieldRef }
                          })
                        : _c("formulate-group-adapter", {
                            key: field.name,
                            attrs: {
                              disabled: _vm.viewOnly,
                              debug: _vm.debug,
                              value: field,
                              "show-criteria": _vm.showCriteria
                            },
                            on: { "mounted-field": _vm.loadFieldRef }
                          })
                    ]
                  })
                ],
                2
              )
            ]
          )
        ],
        { fieldDefinitions: _vm.fieldDefinitions }
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }